export default "__VITE_ASSET__BK4nzvLy__"